import AirbrakeClient from 'airbrake-js';
import { applyMiddleware, createStore } from 'redux';
import airbrakeMiddleware from 'redux-airbrake';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers/index';

const loggerMiddleware = createLogger();
const initialState = {};

let middleware = [thunkMiddleware];

if (process.env.NODE_ENV === 'production') {
  const airbrakes = new AirbrakeClient({
    projectId: 1,
    projectKey: '6189bc98c9bf9f15ec9bf40adf5d0b3e',
    host: 'https://errbit.sla-alacrity.com',
    environment: process.env.REACT_APP_ENVIRONMENT,
  });

  const errorMiddleware = airbrakeMiddleware(airbrakes, {
    sendLastAction: true,
    sendState: true,
  });
  middleware = [...middleware, errorMiddleware];
} else {
  middleware = [...middleware, loggerMiddleware];
}

const configureStore = () => ({
  ...createStore(rootReducer(), initialState, applyMiddleware(...middleware)),
});
export default configureStore;
